// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-panel[data-v-6ab6d576]{border:1px solid var(--border);border-radius:5px;padding:10px;position:relative;margin-top:10px}.group-panel .group-panel-title[data-v-6ab6d576]{position:absolute;top:-7px;background-color:var(--body-bg);padding:0 5px}.group-panel .group-panel-content[data-v-6ab6d576]{position:relative}", ""]);
// Exports
module.exports = exports;
